import React, { useEffect, useMemo, useState } from 'react'
import { AlertType, DadosRelDiaCtaPagar, ItensVendas, RetAPI, VendasRelatorio, bgLineGridColorDark, bgLineGridColorLight, contaAPagar, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { ContaAPagarService } from '../../Pages/ContasAPagar/ContaAPagarService'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { IoCreate, IoTrash } from 'react-icons/io5'
import { Funcoes } from '../../Utils/Funcoes'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

type Props = {
    relItensPeriodo: ItensVendas[],
}

interface RowData {

    id: number,
    desc_prod: string,
    cod_barra: string,
    qtde: number,
    vl_unit: number,
    vl_tot: number,
    vl_custo: number,
    vl_desc: number,
    
}

type VisibilityState = Record<string, boolean>

export const GridRelPeriodoItens = React.memo(({ relItensPeriodo }: Props) => {

    const xJson = localStorage.getItem("@commerce/column_grid_rel_itens_periodo")

    let json: any = {
        id_venda: true,
        desc_prod: true,
        cod_barra: true,
        qtde: true,
        vl_unit: true,
        vl_tot: true,
        vl_custo: true,
        vl_desc: true,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_rel_itens_periodo") || '')
    }

    //const [feedBackVisible, setFeedBackVisible] = useState(false)
    //const [messageFeedBack, setMessageFeedBack] = useState("")
    //const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(json)

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light'
                        ? '#fff' // modo claro
                        : '#475569', //modo escuro
            },
        },
    })

    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.id_venda = json.id_venda
                newColumnVisibility.desc_prod = json.desc_prod
                newColumnVisibility.cod_barra = json.cod_barra
                newColumnVisibility.qtde = json.qtde
                newColumnVisibility.vl_unit = json.vl_unit
                newColumnVisibility.vl_tot = json.vl_tot
                newColumnVisibility.vl_custo = json.vl_custo
                newColumnVisibility.vl_desc = json.vl_desc
            }
        }
    }, [])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_rel_itens_periodo", JSON.stringify(columnVisibility))
    }, [columnVisibility])

    const baseBackgroundColor =
        user.modeDark === 'dark'
            ? '#475569'
            : '#fff'

    const colunas = useMemo<MRT_ColumnDef<ItensVendas>[]>(
        () => [

            {
                accessorKey: 'id_venda', header: 'Venda', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.id ? rowData.id : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'desc_prod', header: 'Descrição', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.desc_prod ? rowData.desc_prod : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'cod_barra', header: 'Código de Barra', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.cod_barra ? rowData.cod_barra : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'qtde', header: 'Quantidade', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.qtde ? Funcoes.numberFormat(rowData.qtde, 'decimal') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'vl_unit', header: 'Valor Unitário', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_unit ? Funcoes.numberFormat(rowData.vl_unit, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'vl_tot', header: 'Valor Total', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_tot ? Funcoes.numberFormat(rowData.vl_tot, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'vl_custo', header: 'Valor de Custo', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_custo ? Funcoes.numberFormat(rowData.vl_custo, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
                }
            },

            {
                accessorKey: 'vl_desc', header: 'Valor Desconto', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.vl_desc ? Funcoes.numberFormat(rowData.vl_desc, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: relItensPeriodo,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

        </>
    )

})